import { render, staticRenderFns } from "./g1-assistant.vue?vue&type=template&id=f32120fe&scoped=true&"
import script from "./g1-assistant.vue?vue&type=script&lang=js&"
export * from "./g1-assistant.vue?vue&type=script&lang=js&"
import style0 from "./g1-assistant.vue?vue&type=style&index=0&id=f32120fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32120fe",
  null
  
)

export default component.exports